<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2> منابع قسمت: {{name}}</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                          <div class="col-12">
                            <treeselect
                                :async="true"
                                @select="select_url"
                                :load-options="load_uploader"
                                placeholder="جستجو لینک"
                                :normalizer="normalizer_uploader"
                            />
                          </div>

                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="link" type="text" class="form__input" placeholder="لینک">
                                </div>
                            </div>


                        </div>
                    </div>


                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button type="button" class="form__btn" @click="insert_data2">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">

            <div class="row">
                <!-- main title -->
                <!-- end main title -->

                <!-- users -->
                <div class="col-12">
                    <Datatable
                            :items="items"
                            :fields="fields"
                            style="overflow: auto"
                            :items-per-page="20"
                            hover
                            height="300px"
                            border
                            striped
                            sorter
                            column-filter
                            pagination
                    >
                        <template #row="{item,index}">
                            <td>
                                <div class="main__table-text">{{index+1}}</div>
                            </td>
                        </template>
                        <template #operation="{item}">
                            <td>
                                <div class="main__table-btns">
                                    <!--                                    <div datas="#modal-status" class="main__table-btn main__table-btn&#45;&#45;banned open-modal">-->
                                    <!--                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,13a1.49,1.49,0,0,0-1,2.61V17a1,1,0,0,0,2,0V15.61A1.49,1.49,0,0,0,12,13Zm5-4V7A5,5,0,0,0,7,7V9a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V12A3,3,0,0,0,17,9ZM9,7a3,3,0,0,1,6,0V9H9Zm9,12a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Z"/></svg>-->
                                    <!--                                    </div>-->
                                    <!--                                    <div datas="#" class="main__table-btn main__table-btn&#45;&#45;view">-->
                                    <!--                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"/></svg>-->
                                    <!--                                    </div>-->
                                    <div @click="edit_item(item)" datas="#"
                                         class="main__table-btn main__table-btn--edit">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>
                                        </svg>
                                    </div>
                                    <div @click="delete_item(item)" datas="#modal-delete"
                                         class="main__table-btn main__table-btn--delete open-modal">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"/>
                                        </svg>
                                    </div>
                                </div>
                            </td>
                        </template>
                    </Datatable>

                </div>


            </div>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";
    import Treeselect, {ASYNC_SEARCH} from "vue3-treeselect";
    import 'vue3-treeselect/dist/vue3-treeselect.css'
    // import the styles
    const simulateAsyncOperation = fn => {
      setTimeout(fn, 200)
    }
    export default {
        name: 'HelloWorld',
        data() {
            return {
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'link', label: 'لینک'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                name: '',
                link: '',
              load_uploader({action, searchQuery, callback}) {

                if (action === ASYNC_SEARCH) {
                  simulateAsyncOperation(() => {
                    let options;
                    axios.post('search_upload_video', {
                      search: searchQuery,

                    }).then(function (response) {
                      options = response.data;
                      callback(null, options);
                      // localStorage.setItem("api_token", response.data.access_token);
                      // self.$router.push({ path: 'notes' });
                    })
                        .catch(function (error) {

                          console.log(error);
                        });


                    //  const options = this.get_keywords(searchQuery);
                    // const options = [1, 2, 3, 4, 5].map(i => ({
                    //     id: `${searchQuery}-${i}`,
                    //     name: `${searchQuery}-${i}`,
                    // }))

                  })
                }
              },
              normalizer_uploader(node) {
                return {
                  id: node.id,
                  label: node.title,
                }
              },
            }
        },
        components: {
            Datatable,
          Treeselect
        },
        mounted() {
            this.get_data2();
        },
        methods: {
          select_url(node ,id){
            this.link = node.url
          },
            edit_item(item) {
                this.link = item.link;
                this.status_form = item.id;
            },
            get_data2() {

                var self = this;

                var formData = new FormData();
                formData.append('episode_id', this.$route.params.episode_id);

                this.axios.post('get_episode_with_source', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.items = content_data.sources

                    self.name = content_data.name
                }).catch(function (error) {
                    console.log(error);
                });


            },
            insert_data2() {

                var self = this;
                if (this.name == "") {
                    return
                }
                var formData = new FormData();
                var url = 'insert_episode_source'
                formData.append('link', this.link);
                formData.append('episode_id', this.$route.params.episode_id);
                if (this.status_form != 0) {
                    formData.append('id', this.status_form);
                    url = 'update_episode_source'
                }
                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data2()
                    self.link = ''
                    self.status_form = 0;
                    self.$toast.success('ثبت با موفقیت انجام شد');

                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },
        }
    }
</script>

